import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'powerIcon'
})
export class PowerIconPipe implements PipeTransform {

  transform(powerName: string): any {
    const path = powerName.replace('PWR_', '').replace('_', '-').toLowerCase();

    return `app2/assets/powers/operator/${ path }.svg`;
  }

}
